export const MODE_IMAGE = 'hero-mode-image';
export const MODE_VIDEO = 'hero-mode-video';
export const MODE_IMAGE_V2 = 'hero-mode-image-v2';
